<template>
  <div style="padding: 20px; background: #fff">
    <h1 class="com-title com-ht tree-title" style="padding-top: 0">
      <i></i>
      <span class="ms">合同盖章时的审批流程，审批通过后合同才能成功盖章 </span>
    </h1>
    <div class="shearch-lab">
      <!-- v-if="perms.includes(gantConf.sealApproval)" -->
      <el-button type="primary" size="small" plain @click="addFlow"
        >{{!isInDingTalk ? '新增用印审批' : '新增钉钉用印审批'}}</el-button
      >
      <div>
        <el-form :inline="true" :model="signFilter" size="small">
        <el-form-item>
          <el-input
            style="width: 220px"
            v-model="signFilter.flowName"
            placeholder="流程名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 120px"
            v-model="signFilter.orderFlag"
            placeholder="请选择流程"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="顺序审批" :value="1"></el-option>
            <el-option label="会审" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 120px"
            v-model="signFilter.useStatus"
            placeholder="请选择状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="启用中" :value="0"></el-option>
            <el-option label="已停用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-right:0px">
          <el-button @click="filterSearch">查询</el-button>
          <el-button size="small" @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
      </div>
    </div>
    <el-table :data="signTableData" style="width: 100%" border>
      <el-table-column prop="flowName" label="流程名称" min-width="200"> </el-table-column>
      <el-table-column prop="orderFlag" label="审批流程" min-width="200">
        <template slot-scope="scope">
          <span v-if="isInDingTalk"
            >{{ `${scope.row.flowType === 1 ? "顺序审批：" : "会审："} ` }}
            <template v-if="scope.row.flowType === 1">
              <span v-for="(node, i) of scope.row.nodes" :key="i">
                {{ node.userApproveUsers[0].name }}
                <span v-if="i < scope.row.nodes.length - 1">{{ `->` }}</span>
              </span>
            </template>
            <template v-else>
              <span
                v-for="(node, i) of scope.row.nodes[0].userApproveUsers"
                :key="i"
              >
                {{ node.name }}
                <span v-if="i < scope.row.nodes[0].userApproveUsers.length - 1"
                  >、</span
                >
              </span>
            </template>
          </span>
          <span v-else>{{
            `${scope.row.orderFlag === 1 ? "顺序审批：" : "会审："}${
              scope.row.allPartName
            }
            `
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="200"
        v-if="!isInDingTalk"
      >
      </el-table-column>

      <el-table-column prop="useStatus" label="启用状态" width="200">
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.useStatus === 1
                  ? '#adadad'
                  : scope.row.useStatus === 0
                  ? '#67C23A'
                  : '#Ec1c1c',
            }"
          >●&nbsp;</span
          ><span>{{
            scope.row.useStatus === 1
              ? "已停用"
              : scope.row.useStatus === 0
              ? "启用中"
              : "已删除"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <div class="handle-wrap">
            <p
              class="color-success"
              :class="{ 'dis-style': !haveAuth }"
              @click="addFlow({row:scope.row})"
            >
              编辑
            </p>
            <p
              class="color-success"
              :class="{ 'dis-style': !haveAuth }"
              @click="switchStatus(scope.row)"
            >
              {{ scope.row.useStatus === 1 ? "启用" : "停用" }}
            </p>
            <p
              class="color-success"
              :class="{
                'dis-style':
                  !haveAuth || (haveAuth && scope.row.useStatus !== 1),
              }"
              @click="del(scope.row)"
            >
              <el-tooltip
                v-if="scope.row.useStatus === 0"
                effect="light"
                content="流程启用中，不可删除"
                placement="bottom-end"
              >
                <span>删除</span>
              </el-tooltip>
              <span v-else>删除</span>
            </p>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="pageation">
      <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="signFilter.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="signFilter.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="signFilter.pageTotal"
        />
        <el-go
          :page-size="signFilter.pageSize"
          :total="signFilter.pageTotal"
          @current-change="handleCurrentChange"
          style="margin-right: 5px"
        ></el-go>
      </el-col>
    </el-row>
    <!-- 新增流程窗口 -->
    <el-dialog
      :title="pupTitle"
      :visible.sync="addFlowPupVisi"
      width="65%"
      top="13vh"
      :show-close="false"
      lock-scroll
    >
      <template>
        <template v-if="isInDingTalk"
          ><ding-sign-approval
            v-if="addFlowPupVisi"
            :addFlowPupVisi.sync="addFlowPupVisi"
            :currentFlowId="currentFlowId"
            :currentFlow="currentFlow"
            @filterSearch="filterSearch"
          ></ding-sign-approval
        ></template>

        <sign-approval
          v-else
          :addFlowPupVisi.sync="addFlowPupVisi"
          :currentFlowId="currentFlowId"
          @filterSearch="filterSearch"
        ></sign-approval>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import dingSignApproval from "../dingComponents/dingSignApproval.vue";
import signApproval from "../signApproval.vue";
import FlowTable from "@/components/corp-comps/FlowTable";
import ElGo from "@/components/go/Go";
import useFileAuditFlag from "@/components/corp-comps/switch-btn";
import { callbackLog } from "@/assets/js/utils/publicMethods";

// data
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
// API
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi.js";
import { isInDingTalk } from "../../../assets/js/utils/ding-env";

export default {
  data () {
    return {
      pupTitle:'新增流程',
      currentFlowId: "",
      currentFlow: '',
      isInDingTalk,
      gantConf,
      signFilter: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: "",
      },
      signTableData: [],
      addFlowPupVisi: false,
    };
  },
  methods: {
    /**
     * 启用、停用
     */
    async switchStatus (row) {
      const bool = this.permsEven();
      if (!bool) return;
      if (isInDingTalk) return this.dingSwitch(row)
      let param = {
        flowId: row.flowId,
        useStatus: row.useStatus === 0 ? 1 : row.useStatus === 1 ? 0 : 1,
      };
      let res = await ApiCorpMethods.FlowController.switchFlow(param);
      if (res.success) {
        this.$message.success(res.description || "操作成功");
        // 直接修改状态，不需要调用分页查询接口
        row.useStatus = param.useStatus;
      } else {
        this.$message.error(res.description || "操作失败，请重试");
      }
    },
    /**
     * 启用、停用
     */
    async dingSwitch (row) {
      const { dingTalkCorpId, dingTalkUserId } = JSON.parse(
        sessionStorage.getItem("dingloginInfo")
      );
      let param = {
        flowId: row.flowId,
        status: row.status === 0 ? 1 : 0,
        corpId: dingTalkCorpId,
        dingTalkUserId
      };
      let res = await dingtalkApi.updateStatus(param);
      if (res.success) {
        const {flowId,flowName,status}=row
            callbackLog({
          module:6,
          desc:`${status !== 1 ? '停用' : '启用'}审批流程：${flowName}(ID：${flowId})`
          })
        this.$message.success(res.description || "操作成功");
        // 直接修改状态，不需要调用分页查询接口
        row.status = param.status;
        row.useStatus = param.status
      } else {
        this.$message.error(res.description || "操作失败，请重试");
      }
    },
    /**
     * 删除
     */
    del (row) {
      if (!this.haveAuth || (this.haveAuth && row.useStatus !== 1)) return;
      const bool = this.permsEven();
      if (!bool) return;
      if (isInDingTalk) return this.dingDel(row)
      this.$confirm("是否删除审批流程", "系统提示")
        .then(async () => {
          // 删除接口
          let res = await ApiCorpMethods.FlowController.delFlow({ flowId: row.flowId });
          if (res.success) {
            this.$message.success(res.description || "删除审批流程成功");
            this.filterSearch();
          } else {
            this.$message.error(res.description || "操作失败");
            this.filterSearch();
          }
        })
        .catch(() => { });
    },
    /**  钉钉删除 */
    dingDel (row) {
      this.$confirm("是否删除审批流程", "系统提示")
        .then(async () => {
          // 删除接口
          const { dingTalkCorpId, dingTalkUserId } = JSON.parse(
            sessionStorage.getItem("dingloginInfo")
          );
          let param = {
            flowId: row.flowId,
            status: 2,
            corpId: dingTalkCorpId,
            dingTalkUserId
          };
          let res = await dingtalkApi.updateStatus(param);
          if (res.success) {
            const {flowId,flowName}=row
            callbackLog({
              module:6,
              desc:`删除审批流程：${flowName}(ID：${flowId})`
            })
            this.$message.success(res.description || "删除审批流程成功");
          } else {
            this.$message.error(res.description || "操作失败");
          }
        })
        .catch(() => { }).finally(() => { this.filterSearch() });
    },
    /** 是否复用 */
    changeFn (val, row) {
      console.log(val, row);
      ApiCorpMethods.FlowController.switchFlowFlag({
        flowId: row.flowId,
        useFileAuditFlag: val,
      }).then((res) => {
        if (!res.success) return this.$message.error(res.description);
        row.useFileAuditFlag = val;
        this.$message.success(res.description);
      });
    },
    /** 权限验证 */
    permsEven (pid = gantConf.sealApproval) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid);
        this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`);
      }
      return bool;
    },
    /** 页数切换 */
    handleCurrentChange (val) {
      this.signFilter.itemPage = val;
      this.querySign();
    },
    /** 每页条数change */
    handleSizeChange (val) {
      this.signFilter.itemPage = 1;
      this.signFilter.pageSize = val;
      this.querySign();
    },
    /** 发起审批 */
    addFlow ({row}) {
      // 盖章审批
      const bool = this.permsEven();
      if (!bool) return;
      this.pupTitle='新增流程'
      if (row) {
        this.currentFlowId = row.flowId;
        this.currentFlow = row;
        this.pupTitle='编辑流程'
      }     
      // if (isInDingTalk) {
      //   this.$router.push({
      //     path: '/console/dingComponents/approval',
      //     query: { flowType: 1 }
      //   });
      // } else {
      this.addFlowPupVisi = true;
      // }
    },
    /** 重置 */
    resetFilter () {
      this.signFilter = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: "",
      };
      this.filterSearch();
    },
    /** 搜索按钮 */
    filterSearch () {
      this.signFilter.itemPage = 1;
      this.querySign();
    },
    /** 查询盖章审批 */
    async querySign () {
      let param = Object.assign({}, this.signFilter, { flowType: 1 });
      let res = {};
      if (isInDingTalk) {
        const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(
          sessionStorage.getItem("dingloginInfo")
        );

        param.corpId = corpId;
        param.dingTalkUserId = dingTalkUserId;
        (param.useScopeType = 1), // 使用范围类型,0:合同,1:印章
          (param.page = param.itemPage);
        res = await dingtalkApi.flowlistByPage(param);
      } else {
        res = await ApiCorpMethods.FlowController.pageFlow(param);
      }
      if (!res.success) {
        return this.$message.error(res.description || "查询数据失败");
      }
      if (isInDingTalk) {
        res.data.forEach(elem => {
          elem.useStatus = elem.status
        });
      }
      this.signTableData = res.data;
      this.signFilter.pageTotal = res.total;
      this.signFilter.pageSize = res.pageSize;
      this.signFilter.pageNum = res.pageNum;
      this.signFilter.pages = res.pages;
    },
  },
  components: {
    FlowTable,
    ElGo,
    useFileAuditFlag,
    dingSignApproval,
    signApproval,
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    haveAuth () {
      return this.perms.includes(gantConf.sealApproval);
    },
  },
  created () {
    this.querySign();
    // this.$nextTick(() => {
    //   this.operationAuthFn();
    // });
  },
  watch: {
    addFlowPupVisi (newVal) {
      if (!newVal) {
        this.currentFlowId = "";
        this.currentFlow = '';
      }
    },
  }
};
</script>

<style scoped lang="less">
.shearch-lab{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
}
.handle-wrap {
  & > p {
    font-size: 14px;
    cursor: pointer;
    color: #290202;
    font-weight: bold;
  }

  .color-success:hover {
    color: #ec1c1c;
  }
  .dis-style {
    color: #ccc;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/components/signSet.vue